import { apiSlice } from "../../app/apiSlice";
import { API_ENDPOINTS } from "../../constants/apiEndpoints";
import type {
	CredentialsLoginRequest,
	LoginResponse,
	SamlExchangeRequest,
} from "./auth.types";
import { parseLoginResponse } from "./auth.utils";

export const authApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<LoginResponse, CredentialsLoginRequest>({
			query: (body) => ({
				url: API_ENDPOINTS.auth.login,
				method: "POST",
				body,
			}),
			transformResponse: parseLoginResponse,
			invalidatesTags: ["Auth"],
		}),
		exchangeSamlCode: builder.mutation<LoginResponse, SamlExchangeRequest>({
			query: (body) => ({
				url: API_ENDPOINTS.auth.samlExchange,
				method: "POST",
				body,
			}),
			transformResponse: parseLoginResponse,
			invalidatesTags: ["Auth"],
		}),
		logout: builder.mutation<void, void>({
			query: () => ({
				url: API_ENDPOINTS.auth.logout,
				method: "POST",
			}),
			invalidatesTags: ["Auth"],
		}),
		refreshToken: builder.mutation<
			{ accessToken: string; refreshToken: string },
			{ refreshToken: string }
		>({
			query: (body) => ({
				url: API_ENDPOINTS.auth.refresh,
				method: "POST",
				body,
			}),
		}),
		getCurrentUser: builder.query<LoginResponse["user"], void>({
			query: () => API_ENDPOINTS.auth.me,
			transformResponse: (raw) => parseLoginResponse(raw).user,
			providesTags: ["Auth"],
		}),
	}),
});

export const {
	useLoginMutation,
	useExchangeSamlCodeMutation,
	useLogoutMutation,
	useGetCurrentUserQuery,
	useRefreshTokenMutation,
} = authApi;
